import { css } from '@emotion/react';

export const container = css({
  position: 'relative',
  marginTop: '80px',
  height: '640px',
  overflow: 'hidden'
});

export const scrollContainer = css({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  rowGap: '24px',
  width: '100%',
  transition: '.5s',
  willChange: 'transform'
});
